import React, { Component, useState, useRef, Fragment } from 'react'
import { useMount } from 'react-use'
import { sagaModal } from 'redux-saga-modal'
import { Form, Modal, Button, message, Select, Input, InputNumber, Icon } from 'antd'
import styles from './styles.module.scss'
import * as apis from '@/apis'
import UploadImage from "@/components/UploadImage/Upload";
const formItemLayout = {
  labelCol: { span: 5 },
  wrapperCol: { span: 17 },
}

@Form.create()
class DeductionDepositForm extends Component {
  state = {
    loading: false,
  }

  handleSubmit = e => {
    const { submit } = this.props
    e.preventDefault()
    this.props.form.validateFields((err, values) => {
      if (err) {
        Object.entries(err).forEach(([_, { errors }]) => {
          errors.forEach(({ message: msg }) => {
            message.error(msg)
          })
        })
        return console.error(err)
      }
      const submitData = values
      submitData.images = submitData.images.map(item => item.url)
      submit(submitData)
    });
  }



  render() {
    const { tenant, worker } = this.props
    const { getFieldDecorator, validateFields, getFieldValue, setFieldsValue } = this.props.form


    return (
      <div>
        <Form onSubmit={this.handleSubmit}>
          <Form.Item
            {...formItemLayout}
            label="当前保证金余额">
            {tenant ? tenant.baozheng?.toFixed(2) : worker?.baozheng?.toFixed(2)}元
          </Form.Item>
          <Form.Item
            {...formItemLayout}
            label="扣除金额">
            {getFieldDecorator('chargeback', {
              rules: [
                {
                  required: true,
                  message: '请输入扣除金额',
                },
              ],
            })(
              <InputNumber style={{ width: 320 }} placeholder="请输入扣除金额" />
            )}
            <span style={{ marginLeft: 5 }}>元</span>
          </Form.Item>
          <Form.Item
            {...formItemLayout}
            label="扣款事由"
          >
            {getFieldDecorator('reason', {
              rules: [
                {
                  required: true,
                  message: '请输入扣款事由',
                },
              ],
            })(
              <Input.TextArea rows={3} placeholder="请输入扣款事由" />
            )}
          </Form.Item>
          <Form.Item
            {...formItemLayout}
            label="扣款工单">
            {getFieldDecorator('orderNo', {
              rules: [
                {
                  required: true,
                  message: '请输入扣款工单号',
                },
              ],
            })(
              <Input placeholder="请输入扣款工单号" />
            )}
          </Form.Item>
          <Form.Item
            {...formItemLayout}
            label="照片"
          >
            {getFieldDecorator('images', {
              rules: [
                { required: true, message: `请上传照片` },
              ],
            })(
              <UploadImage />
            )}
          </Form.Item>
          <div className={styles.footer}>
            <Button type="primary" htmlType="submit">提交</Button>
          </div>
        </Form>
      </div>
    )
  }
}

const DeductionDeposit = ({
  modal,
  isOpen,
  show,
  update,
  destroy,
  click,
  submit,
  hide,
  showModal,
  updateModal,
  submitModal,
  clickModal,
  hideModal,
  destroyModal,
  ...ownProps
}) => (
  <Modal
    title={ownProps.title}
    destroyOnClose
    footer={null}
    width={650}
    centered
    visible={isOpen}
    onCancel={hide}>
    <DeductionDepositForm submit={submit} {...ownProps} />
  </Modal>
)

export default sagaModal({
  name: 'DEDUCTION_DEPOSIT',
})(DeductionDeposit)
